import { Chip } from '@mui/material'
import React from 'react'
import { number } from 'prop-types'

/**
 * @param {value} number
 * @returns
 */

const StatusRhChip = ({ value }) => {
  const checkStatus = value => {
    const status = {
      1: {
        name: 'Em Análise',
        color: 'warning'
      },
      2: {
        name: 'Aprovado',
        color: 'success'
      },
      3: {
        name: 'Reprovado',
        color: 'error'
      }
    }
    return status[value]
  }

  return (
    <Chip
      sx={{ cursor: 'pointer' }}
      color={checkStatus(value)?.color}
      label={checkStatus(value)?.name}
    />
  )
}
StatusRhChip.propTypes = {
  value: number
}

export default StatusRhChip
